/* global axios */
import ApiClient from './ApiClient';

class PmaWorkbenchActionsAPI extends ApiClient {
  constructor() {
    super('pma/workbench_actions', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, data);
  }
}

export default new PmaWorkbenchActionsAPI();
